import React from "react"
import Layout from "../components/static-layout"
import Footer from "../components/tailwind-footer"
import { Helmet } from "react-helmet"

class Welcome extends React.Component {
  render() {
    return (
      <React.Fragment>
        <Helmet>
          <meta http-equiv="Refresh" content="1; url='myradar://welcome'" />
        </Helmet>
        <Layout>
          <div className="not-found">
            <div className="inside">
              <h1>Welcome</h1>
              <div className="sep"></div>
              <p>
                Your email has been verified. Please open MyRadar on your mobile
                device.
              </p>
              <a href="myradar://" className="button">
                Open App
              </a>
              <div className="desk"></div>
            </div>
          </div>
        </Layout>
        <Footer />
      </React.Fragment>
    )
  }
}

export default Welcome
